<template>
  <v-dialog
    v-model="isDialogOpen"
    persistent
    lazy
    contentClass="setupPasswordDialog"
    maxWidth="487"
  >
    <ChangePassword :handleSubmit="handleSubmit" />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

import ChangePassword from '@/components/organisms/changePassword/changePassword.vue'
import { eventBus } from '@/main'
import logger from '@/sdk/logger'

export default {
  name: 'SetupPasswordDialog',

  components: {
    ChangePassword,
  },

  data() {
    return {
      isDialogOpen: false,
    }
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    ...mapActions({
      setPassword: 'user/setPassword',
    }),

    trackEvent({ action }) {
      this.$gtm.trackEvent({
        category: 'setup password overlay',
        action,
      })
    },

    async handleSubmit(password) {
      try {
        await this.setPassword(password)
        this.handleSubmitSuccess()
      } catch (error) {
        this.handleSubmitError(error)
      }
    },

    handleSubmitError(error) {
      this.trackEvent({ action: 'user password setup failure' })

      logger.error('failed setting up a password', {
        error,
        tags: ['dashboard', 'http', 'setupPassword', 'user'],
      })

      eventBus.$emit(
        'showSnackbarMessage',
        this.translate('SOMETHING_WENT_WRONG'),
        { color: 'error' },
      )
    },

    handleSubmitSuccess() {
      this.isDialogOpen = false
      this.trackEvent({ action: 'user password setup success' })
    },
  },

  watch: {
    isOpen(val) {
      this.isDialogOpen = val
    },
  },
}
</script>
